/** F606 Food Analyses page — AI meal-photo analysis history. */
import { Apple } from 'lucide-react';
import F606DataPage from './F606DataPage';

export default function F606FoodAnalysesPage() {
  return (
    <F606DataPage
      entity="food-analyses"
      titleAr="تحليل الغذاء"
      titleEn="Food analyses"
      icon={Apple}
      emptyIcon={Apple}
      columns={[
        {
          key: 'id',
          ar: '#', en: '#',
          render: (r) => <span className="font-mono text-white/40 text-[10px]" dir="ltr">{String(r.id || '').slice(0, 8)}</span>,
          className: 'w-20',
        },
        { key: 'user_name', ar: 'المستخدم', en: 'User', render: (r) => r.user_name || '—' },
        {
          key: 'foods',
          ar: 'الطعام', en: 'Food',
          render: (r) => (
            <div>
              <div className="font-bold text-white truncate max-w-md">
                {Array.isArray(r.foods) ? r.foods.map((f) => f.name || f).join(', ') : (r.food_name || r.title || '—')}
              </div>
              {r.meal_type && <div className="text-[10px] text-white/40">{r.meal_type}</div>}
            </div>
          ),
        },
        { key: 'calories', ar: 'السعرات', en: 'Cal', render: (r) => r.calories != null ? <span className="font-mono text-amber-300" dir="ltr">{Number(r.calories).toFixed(0)}</span> : '—', className: 'w-20 text-center' },
        {
          key: 'macros',
          ar: 'الماكروز', en: 'Macros',
          render: (r) => (
            <span className="text-[10px] font-mono text-white/60" dir="ltr">
              P{r.protein_g ?? '—'} · C{r.carbs_g ?? '—'} · F{r.fat_g ?? '—'}
            </span>
          ),
          className: 'w-40',
        },
        {
          key: 'created_at',
          ar: 'التاريخ', en: 'When',
          render: (r) => r.created_at ? new Date(r.created_at).toLocaleString() : '—',
          className: 'w-36 text-[11px] text-white/60',
        },
      ]}
    />
  );
}
